module.exports = __webpack_public_path__ + "img/addCar.6dba6931.png";